<template>
  <section class="col-md-12" style="margin-bottom: 30px">
    <div class="card">
      <div class="card-header">
        <a href="/my-encounters">
          <button class="btn btn-outline-success spacer">
            View Encounters
          </button>

        </a>


        <button class="btn btn-outline-primary spacer" @click="getSector(currentPage, sector.name)"
        v-for="sector in sectors" :key="sector.name"
        >
          {{ sector.code }}
        </button>
      </div>
      <div class="card card-body">
        <highcharts :options="chartOptions"></highcharts>

        <b-pagination
          v-model="currentPage"
          :total-rows="charts[0].lga.data.total"
          :per-page="perPage"
          limit="10"
          aria-controls="my-table"
          @input="getDashboardLGA(currentPage ? currentPage : 1)"
        ></b-pagination>

        <div class="row">
          <div class="col-md-6">
            <label for="inputCity">Start</label>
            <input type="date" class="form-control" v-model="from" />
          </div>
          <div class="col-md-6">
            <label for="inputCity">End</label>
            <input type="date" class="form-control" v-model="to" />
          </div>

          <div class="col-md-12 mt-4">
            <button
              class="btn btn-outline-success btn-block"
              @click="getDashboardLGA(currentPage ? currentPage : 1)"
            >
              Filter
            </button>
          </div>


          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
moment().format();

export default {

  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      sectors: [
          {
            code:"BHCPF",
            name:"Basic Healthcare Provision Fund",
          },
          {
            code:"SEP",
            name:"State Equity Program",
          },
          {
            code:"VOL",
            name:"Voluntary Contributor",
          },
          {
            code:"SPS",
            name:"State Public Servant",
          },
          {
            code:"SCS",
            name:"State Civil Servant",
          }
      
        ],
        sector: "Basic Healthcare Provision Fund",
      title: "",
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      charts: [
        {
          lga: {
            data: {},
          },
        },
      ],
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      chartOptions: {},
      perPage: 70,
      currentPage: 1,
      rows: "1",
      from: moment().subtract(30, "days").format("YYYY-MM-DD"),
      to:  moment().format("YYYY-MM-DD"),
    };
  },
  mounted() {
    this.getDashboardLGA(1);
  },
  methods: {
    getDashboardLGA(currentPage) {
      // this.isLoading =true;
      this.$batchGet("/api/v1/auth/diagnosisChart/90?page=" + currentPage, {
          params: {
            from: this.from,
            to: this.to,
            sector: this.sector,
          },
        })
        .then((response) => {
          console.log(response);
          // this.isLoading =false;
           this.$toasted.info("Queried Successfully!", {
            position: "top-center",
            duration: 8000,
          });

          var data = response.data;
          this.charts = response.data;
          this.chartOptions = {
            chart: {
              type: "column",
            },
            title: {
              text: this.sector + " Encounter Chart for " + this.from + ' to ' + this.to,
            },
            subtitle: {
              text: "Provider Visitation Analysis for Based on Diagnosis",
            },
            accessibility: {
              announceNewData: {
                enabled: true,
              },
            },
            xAxis: {
              type: "category",
            },
            yAxis: {
              title: {
                text: "NUMBER OF VISITATIONS FOR DIAGNOSES",
              },
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              series: {
                colorByPoint: true,
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                },
              },
            },

            tooltip: {
              headerFormat:
                '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
            },

            series: data[0].lga.data,
          };
        });
    },

    getSector(currentPage,sector) {
        this.sector = sector;
        this.getDashboardLGA(currentPage);
      },
  },
};
</script>
  
  <style>
.spacer {
  margin-left: 1px;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
  